import { BaseDestinationJobFilterHandler } from '../destination-job-filter';

export class InvoiceIdFilter<
  JobData extends object,
> extends BaseDestinationJobFilterHandler<JobData> {
  key = 'invoiceId';
  label = 'Invoice Id';
  description = 'Source Id for the invoice';
}
